import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { IssueTypeDetailViewTopBar } from "./TopBar"

export const issueTypeDetailViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: IssueTypeDetailViewTopBar,
}
